<template>
  <section class="modal">
    <div class="modal-inner relative">
      <div class="modal-scroll">
        <div class="lg:p-4 font-inherit modal-content">
          <slot />
        </div>
      </div>
      <button class="absolute m-6 top-0 right-0 p-0 bg-transparent" type="button" @click="hide">
        <span class="sr-only">Close</span>
        <svg class="w-6" viewBox="0 0 24 24">
          <use xlink:href="#icon-menu-close" />
        </svg>
      </button>
    </div>
  </section>
</template>
<script>
import Mousetrap from "mousetrap";

export default {
  props: {
    isShown: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["hide"],
  data() {
    return {
      bodyScrollSavedPosition: null,
    };
  },
  computed: {
    scrollTop: () => window.pageYOffset || document.documentElement.scrollTop,
  },
  watch: {
    isShown(shown) {
      if (shown) {
        Mousetrap.bind("esc", () => this.hide());
        this.preventBodyScroll();
      } else {
        Mousetrap.unbind("esc");
        this.allowBodyScroll();
      }
    },
  },
  methods: {
    hide() {
      this.allowBodyScroll(!!this._bodyScrollSavedPosition);
      this.$emit("hide");
    },
    preventBodyScroll(savePosition = false) {
      document.body.style.overflow = "hidden";
      if (savePosition) {
        this.scrollPositionSave(this.scrollTop);
      }
    },
    allowBodyScroll(restorePosition = false) {
      document.body.style.overflow = "";
      if (restorePosition) {
        this.scrollPositionApply(this.bodyScrollSavedPosition);
      }
    },
    scrollPositionSave(position) {
      this.bodyScrollSavedPosition = position;
    },
    scrollPositionApply(position) {
      document.documentElement.scrollTop = position;
      document.body.scrollTop = position;
    },
  },
};
</script>
<style scoped>
/*temp*/
.modal {
  display: flex;
  position: fixed;
  z-index: 10000;
  width: 100%;
  height: 100%;
  min-width: 320px;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.modal-inner {
  background: rgba(41, 42, 44, 0.9);
  position: relative;
  height: 100%;
  width: 100%;
}

.modal-scroll {
  max-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  /* Remove bars in IE */
  -ms-overflow-style: -ms-autohiding-scrollbar;

  @media (min-width: 64em) {
    max-height: 90vh;
  }
}

.modal-content {
  height: auto;
}
</style>
